<div class="curriculum-page">
  <header class="page-header">
    <h4>Curriculum & Studiengänge</h4>
    <p>Strukturiere Studiengänge, Kurse pro Semester und Lernziele pro Kurs.</p>
    <button nbButton status="primary" class="page-header__action" (click)="openCreate()">
      <nb-icon icon="plus-outline"></nb-icon>
      Curriculum erstellen
    </button>
  </header>

  <div class="curriculum-grid">
    <!-- Column: Programs -->
    <nb-card class="programs">
      <nb-card-header>Studiengänge</nb-card-header>
      <nb-card-body>
        <ul class="program-list">
          <li
            *ngFor="let p of curriculumService.programs$ | async"
            [class.is-selected]="p.id === selectedProgramId"
          >
            <div class="program-list__row">
              <ng-container *ngIf="renamingProgramId === p.id; else programRow">
                <input
                  nbInput
                  size="small"
                  class="program-list__rename"
                  [(ngModel)]="renameProgramName"
                  (keyup.enter)="saveRenameProgram(p)"
                  (keyup.escape)="cancelRenameProgram()"
                  placeholder="Name des Studiengangs"
                />
                <button
                  nbButton
                  size="tiny"
                  status="primary"
                  nbTooltip="Namen speichern"
                  (click)="saveRenameProgram(p)"
                >
                  <nb-icon icon="checkmark-outline"></nb-icon>
                </button>
                <button
                  nbButton
                  size="tiny"
                  appearance="ghost"
                  nbTooltip="Abbrechen"
                  (click)="cancelRenameProgram()"
                >
                  <nb-icon icon="close-outline"></nb-icon>
                </button>
              </ng-container>

              <ng-template #programRow>
              <button class="program-list__btn" (click)="selectProgram(p.id)">
                <span class="program-list__name">{{ p.name }}</span>
                <span class="program-list__code" *ngIf="p.code">{{ p.code }}</span>
              </button>
              <button
                nbButton
                ghost
                size="tiny"
                status="basic"
                [nbContextMenu]="programMenuItems(p)"
                [nbContextMenuTag]="programMenuTag(p)"
                nbContextMenuTrigger="click"
                title="Aktionen für diesen Studiengang"
                aria-label="Aktionen für diesen Studiengang"
              >
                <nb-icon icon="more-vertical-outline"></nb-icon>
              </button>
              </ng-template>
            </div>
          </li>
        </ul>
      </nb-card-body>
    </nb-card>

    <!-- Curriculum erstellen — opened from the header button. Kept as an
         ng-template so all handlers run in the component context. -->
    <ng-template #createDialog>
      <nb-card class="create-dialog">
        <nb-card-header>Curriculum anlegen</nb-card-header>
        <nb-card-body>
          <section class="create-section">
          <div class="create-modes">
            <button nbButton size="small" [status]="createMode === 'categories' ? 'primary' : 'basic'" (click)="setCreateMode('categories')">Aus Moodle-Kategorien</button>
            <button nbButton size="small" [status]="createMode === 'import' ? 'primary' : 'basic'" (click)="setCreateMode('import')">Aus Dokument</button>
            <button nbButton size="small" [status]="createMode === 'manual' ? 'primary' : 'basic'" (click)="setCreateMode('manual')">Manuell</button>
          </div>

          <!-- Mode: Moodle-Kategorien -->
          <div class="create-panel" *ngIf="createMode === 'categories'">
            <!-- Bulk: whole tree at a chosen level -->
            <div class="bulk-box">
              <h6>Alle Studiengänge auf einmal</h6>
              <p class="hint">Markiere im Kategorie-Baum, welche Kategorien ein <strong>Studiengang</strong> sind. Alles darunter (Jahrgang / Semester / Kurs) wird automatisch zu Gruppen + Kursen. Mehrere möglich, auch auf unterschiedlichen Ebenen.</p>
              <p class="hint" *ngIf="catRows.length === 0">Keine Moodle-Kategorien gefunden (Sync nötig).</p>
              <ul class="cat-tree">
                <li *ngFor="let n of visibleCatRows" class="cat-tree__row" [style.padding-left.px]="n.depth * 18">
                  <button type="button" class="tree-toggle" *ngIf="n.hasChildren" [class.is-open]="isCatExpanded(n.prefix)" (click)="toggleCatExpand(n.prefix)"></button>
                  <span class="tree-toggle tree-toggle--leaf" *ngIf="!n.hasChildren"></span>
                  <nb-checkbox [checked]="isProgramSelected(n.prefix)" (checkedChange)="toggleProgramPrefix(n.prefix)"></nb-checkbox>
                  <span class="cat-tree__name">{{ n.name }}</span>
                  <span class="muted" *ngIf="n.courseCount">· {{ n.courseCount }} Kurse</span>
                </li>
              </ul>
              <nb-checkbox [(ngModel)]="bulkCreateRules">Zuweisungsregeln automatisch anlegen (Lerner werden zugeordnet)</nb-checkbox>
              <button nbButton status="primary" size="small" [disabled]="selectedProgramPrefixes.size === 0" (click)="submitBulk()">
                {{ selectedProgramPrefixes.size }} Studiengänge übernehmen
              </button>
            </div>

            <div class="divider-or"><span>oder einzeln</span></div>

            <p class="hint">Ein Studiengang aus gewählten Kategorien. Jede Kategorie wird eine Gruppe, ihre Kurse werden übernommen.</p>
            <input nbInput fullWidth placeholder="Name (z. B. B.Sc. Informatik)" [(ngModel)]="categoryProgramName" />
            <input nbInput fullWidth placeholder="Kürzel (optional)" [(ngModel)]="categoryProgramCode" />
            <p class="hint" *ngIf="moodleCourses.length === 0">Keine Moodle-Kurse gefunden. Läuft der Moodle-Sync?</p>
            <ul class="cat-picker">
              <li *ngFor="let cat of moodleCourses">
                <label class="cat-picker__row">
                  <nb-checkbox [checked]="isCategorySelected(cat.key)" (checkedChange)="toggleCategory(cat.key)"></nb-checkbox>
                  <span class="cat-picker__label">{{ cat.label }}</span>
                  <span class="muted">({{ cat.count }} Kurse)</span>
                </label>
              </li>
            </ul>
            <label class="module-depth">
              <span class="module-depth__label">Welche Ebene ist ein Modul?</span>
              <nb-select size="small" [(selected)]="categoryModuleDepth" placeholder="Keine">
                <nb-option [value]="null">Keine — Hierarchie nur übernehmen</nb-option>
                <nb-option *ngFor="let d of moduleDepthOptions" [value]="d">Ebene {{ d }}</nb-option>
              </nb-select>
              <span class="hint module-depth__hint">
                Zählt ab der obersten gewählten Kategorie. Gruppen auf dieser Ebene
                werden als Modul markiert — das entscheidet später, worauf sich
                „gehört zusammen" bezieht.
              </span>
            </label>

            <button nbButton status="primary" size="small"
                    [disabled]="!categoryProgramName.trim() || selectedCategoryKeys.length === 0"
                    (click)="submitFromCategories()">Anlegen</button>
          </div>

          <!-- Mode: Manuell -->
          <form *ngIf="createMode === 'manual'" [formGroup]="programForm" (ngSubmit)="submitProgram()" class="program-form">
            <p class="hint">Leerer Studiengang. Struktur + Kurse (aus Moodle) fügst du danach in den Tabs hinzu.</p>
            <input nbInput fullWidth formControlName="name" placeholder="Name (z. B. B.Sc. Informatik)" />
            <input nbInput fullWidth formControlName="code" placeholder="Kürzel (optional)" />
            <textarea nbInput fullWidth formControlName="description" rows="2" placeholder="Beschreibung (optional)"></textarea>
            <button nbButton status="primary" size="small" type="submit" [disabled]="programForm.invalid">Anlegen</button>
          </form>

          <!-- Mode: Import -->
          <div class="import" *ngIf="createMode === 'import'">
            <p class="hint">Lade ein bestehendes Curriculum (PDF/DOCX/TXT — Modulhandbuch, Ausbildungsrahmenplan, Studienordnung) hoch. Es wird per KI analysiert und als Vorschau angezeigt, bevor du es als neuen Studiengang übernimmst.</p>

            <div class="import__upload" *ngIf="importStatus === 'idle'">
              <!-- Same drop zone as the exercise import, not a bare file input:
                   the dialog asks for one document and should look like the
                   rest of the product while doing it. -->
              <label
                class="file-drop"
                [class.drag-over]="importDragOver"
                for="curriculum-import-input"
                (dragover)="onImportDragOver($event)"
                (dragleave)="onImportDragLeave($event)"
                (drop)="onImportFileDropped($event)"
              >
                <nb-icon icon="cloud-upload-outline"></nb-icon>
                <span>{{ 'pages.curriculum.import.choose' | translate }}</span>
                <span class="drop-hint">{{ 'pages.curriculum.import.dropHint' | translate }}</span>
                <input
                  id="curriculum-import-input"
                  type="file"
                  accept=".pdf,.docx,.txt,application/pdf,text/plain,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  (change)="onImportFile($event)"
                />
              </label>

              <p class="error-text" *ngIf="importFileError">{{ importFileError }}</p>

              <div class="file-chip" *ngIf="importFile">
                <nb-icon icon="file-text-outline"></nb-icon>
                <span class="file-name">{{ importFile.name }}</span>
                <span class="file-size">{{ importFile.size / 1024 / 1024 | number : '1.0-2' }} MB</span>
                <button
                  nbButton
                  ghost
                  size="tiny"
                  status="danger"
                  type="button"
                  (click)="clearImportFile()"
                  [attr.aria-label]="'buttons.delete' | translate"
                >
                  <nb-icon icon="close-outline"></nb-icon>
                </button>
              </div>

              <button nbButton size="small" status="primary" [disabled]="!importFile" (click)="startImport()">Analysieren</button>
            </div>

            <div class="import__progress" *ngIf="importStatus === 'queued' || importStatus === 'processing'">
              <nb-icon icon="loader-outline"></nb-icon>
              <span>Dokument wird analysiert … (~1–2 min)</span>
            </div>

            <div class="import__error" *ngIf="importStatus === 'error'">
              <p>{{ importError }}</p>
              <button nbButton size="small" status="basic" (click)="resetImport()">Neu versuchen</button>
            </div>

            <div class="import__preview" *ngIf="importStatus === 'done' && importParsed">
              <h6>Vorschau: {{ importParsed.program_name }}</h6>
              <p class="muted" *ngIf="importParsed.program_code">Kürzel: {{ importParsed.program_code }}</p>
              <ul class="tree-list">
                <li *ngFor="let g of importParsed.groups" class="tree-group">
                  <strong>{{ g.name }}</strong>
                  <ul class="tree-courses">
                    <li *ngFor="let c of g.courses">
                      {{ c.name }}
                      <span class="muted" *ngIf="c.semester">(Semester {{ c.semester }})</span>
                      <span class="muted" *ngIf="c.learning_goals?.length">· {{ c.learning_goals.length }} Lernziel(e)</span>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="import__warnings" *ngIf="importWarnings.length">
                <li *ngFor="let w of importWarnings">{{ w }}</li>
              </ul>
              <div class="import__actions">
                <button nbButton size="small" status="primary" (click)="commitImport()">Übernehmen</button>
                <button nbButton size="small" status="basic" (click)="resetImport()">Verwerfen</button>
              </div>
            </div>
          </div>
          </section>
        </nb-card-body>
        <nb-card-footer>
          <button nbButton status="basic" (click)="closeCreateDialog()">Schließen</button>
        </nb-card-footer>
      </nb-card>
    </ng-template>

    <!-- Column: Curriculum tree-table -->
    <nb-card class="items" *ngIf="selectedProgramId">
      <nb-card-header>
        <div class="tree-toolbar">
          <!-- The agent release is the one consequential switch on this page.
               It used to sit inside the button row as a checkbox in a pill,
               where it read as a fourth button and its agent count as a
               warning stuck to the side. Own row, own words, own status line. -->
          <div class="release-bar" [class.is-live]="programRelease">
            <nb-icon
              class="release-bar__icon"
              [icon]="programRelease ? 'unlock-outline' : 'lock-outline'"
            ></nb-icon>

            <div class="release-bar__text">
              <span class="release-bar__title">Agent-Freigabe</span>
              <span class="release-bar__status">{{ releaseStatusText }}</span>
            </div>

            <span
              class="release-bar__usage"
              *ngIf="programRelease"
              [class.is-idle]="!agentUsage.length"
              [nbTooltip]="agentUsageTooltip"
            >
              {{ agentUsage.length }} Agent{{ agentUsage.length === 1 ? '' : 'en' }}
            </span>

            <nb-toggle
              class="release-bar__toggle"
              [checked]="programRelease"
              (checkedChange)="toggleProgramRelease($event)"
              nbTooltip="Erlaubt Agenten, die Struktur dieses Studiengangs zu lesen: Modul, Nachbarkurse, Lernziele. Kursinhalte anderer Kurse bleiben ausgeschlossen. Einzelne Gruppen oder Kurse lassen sich darunter gezielt sperren."
            ></nb-toggle>
          </div>

          <div class="tree-toolbar__row">
            <div class="tree-toolbar__left">
              <button nbButton size="tiny" status="basic" nbTooltip="Alle Gruppen aufklappen" (click)="expandAll()">Alle aufklappen</button>
              <button nbButton size="tiny" status="basic" nbTooltip="Alle Gruppen zuklappen" (click)="collapseAll()">Alle zuklappen</button>
            </div>

            <div class="tree-toolbar__right">
              <button nbButton size="small" status="basic" nbTooltip="Neue Gruppe auf oberster Ebene anlegen" (click)="addRootGroup()">
                <nb-icon icon="folder-add-outline"></nb-icon>Gruppe
              </button>
              <button nbButton size="small" [status]="showAttrManager ? 'primary' : 'basic'" nbTooltip="Sichtbare Spalten und eigene Felder verwalten" (click)="toggleAttrManager()">
                <nb-icon icon="grid-outline"></nb-icon>Spalten
              </button>
              <button nbButton size="small" [status]="showRules ? 'primary' : 'basic'" nbTooltip="Festlegen, wer als Lerner dieses Studiengangs gilt: aus der Kursbelegung ableiten oder per Regel" (click)="toggleRules()">
                <nb-icon icon="people-outline"></nb-icon>Lernerzuweisung
              </button>
            </div>
          </div>

          <!-- Selection actions get their own row. Squeezed into the toolbar
               they overlapped the permanent controls as soon as a group name
               was long. -->
          <div class="tree-toolbar__bulk" *ngIf="selectedCount">
            <span class="bulk-bar__count">{{ selectedCount }} ausgewählt</span>
            <nb-select
              size="small"
              placeholder="Zielgruppe"
              [(selected)]="bulkTargetGroupId"
              class="bulk-bar__target"
              nbTooltip="Gruppe, in die die ausgewählten Kurse verschoben werden"
            >
              <nb-option [value]="null">Ohne Gruppe</nb-option>
              <nb-option *ngFor="let g of groupOptions" [value]="g.id">{{ g.label }}</nb-option>
            </nb-select>
            <button nbButton size="small" status="primary" nbTooltip="Ausgewählte Kurse in die gewählte Gruppe verschieben" (click)="moveSelectedToGroup()">
              In Gruppe verschieben
            </button>
            <button nbButton size="small" appearance="ghost" nbTooltip="Auswahl zurücksetzen" (click)="clearSelection()">
              Auswahl aufheben
            </button>
          </div>
        </div>
      </nb-card-header>
      <nb-card-body>
        <!-- Verknüpfte Kursinhalte (deckt Ausschreibung 3.2 ab, aber in unserer Sprache) -->
        <section class="rules-panel" *ngIf="prereqCourseId">
          <header class="assign-block__header">
            <h6>Verknüpfte Kursinhalte — {{ prereqCourseName }}</h6>
            <button
              nbButton ghost size="tiny" status="basic"
              class="prereq-close"
              nbTooltip="Schließen"
              (click)="closePrereq()"
            >
              <nb-icon icon="close-outline"></nb-icon>
            </button>
          </header>
          <app-course-prerequisites
            [courseId]="prereqCourseId"
            [courseName]="prereqCourseName"
            [courses]="prereqCourseOptions"
            [canRequest]="prereqMayRequest"
          ></app-course-prerequisites>
        </section>

        <!-- Zuweisungsregeln (einklappbar) -->
        <section class="rules-panel" *ngIf="showRules">
          <p class="hint">Wer gehört zu diesem Studiengang? Zwei Wege: aus der Kursbelegung ableiten (braucht keine Pflege) oder eine Regel schreiben. Manuelle Zuweisungen haben immer Vorrang und bleiben unberührt.</p>
          <!-- Rules belong to one study program; without one selected there is
               nothing to list and nothing to create. -->
          <p class="hint" *ngIf="!selectedProgramId">
            Wähle links einen Studiengang — die Zuweisung gilt immer für einen Studiengang.
          </p>

          <!-- Weg 1: Ableitung. Steht zuerst, weil er nichts braucht außer dem
               Schalter — die Kurse hängen ohnehin schon im Studiengang. -->
          <section class="assign-block" *ngIf="selectedProgramId">
            <header class="assign-block__header">
              <h6>Aus der Kursbelegung ableiten</h6>
              <span class="assign-block__badge" [class.is-on]="autoEnrollOn">
                {{ autoEnrollOn ? 'An' : 'Aus' }}
              </span>
            </header>
            <nb-checkbox
              [checked]="autoEnrollOn"
              (checkedChange)="setAutoEnroll($event)"
              nbTooltip="Wer im LMS in einem Kurs dieses Studiengangs eingeschrieben ist, gilt als Lerner des Studiengangs — ohne dass jemand eine Regel schreibt. Das Semester ergibt sich aus den belegten Kursen. Endet die Kurseinschreibung, fällt die Zuweisung beim nächsten Abgleich weg. Manuelle und Regel-Zuweisungen werden nie überschrieben."
            >
              Lerner automatisch aus ihren Kursen zuordnen
            </nb-checkbox>
            <p class="hint" *ngIf="derivableHint">{{ derivableHint }}</p>
            <div class="rule-apply">
              <button
                nbButton
                status="success"
                size="small"
                [disabled]="!autoEnrollOn || derivePending"
                [nbTooltip]="
                  !autoEnrollOn
                    ? 'Erst die Ableitung einschalten'
                    : 'Zuweisungen jetzt mit der aktuellen Kursbelegung abgleichen — sonst passiert das beim nächsten LMS-Sync'
                "
                (click)="deriveNow()"
              >
                {{ derivePending ? 'Läuft …' : 'Jetzt abgleichen' }}
              </button>
            </div>
          </section>

          <!-- Weg 2: Regeln, für alles was die Ableitung nicht sieht — eine
               ganze Moodle-Kategorie, eine interne Gruppe. -->
          <header class="assign-block__header assign-block__header--standalone">
            <h6>Regeln</h6>
          </header>
          <p class="hint">„Alle Teilnehmer einer Moodle-Kategorie / internen Gruppe → dieser Studiengang". Nötig, wenn die Zuordnung breiter ist als die Kurse, die im Studiengang hängen.</p>
          <table class="items-table">
            <thead>
              <tr><th>Typ</th><th>Schlüssel</th><th>Start-Sem.</th><th>Aktiv</th><th></th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of rules">
                <td>{{ r.rule_type }}</td>
                <td class="muted">{{ r.ref_key || '—' }}</td>
                <td>{{ r.default_start_semester ?? '—' }}</td>
                <td>{{ r.is_active ? 'ja' : 'nein' }}</td>
                <td>
                  <button
                    nbButton
                    ghost
                    size="tiny"
                    status="danger"
                    nbTooltip="Regel löschen"
                    (click)="deleteRule(r.id)"
                  >
                    <nb-icon icon="trash-2-outline"></nb-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="rules.length === 0"><td colspan="5" class="empty">Noch keine Regeln.</td></tr>
            </tbody>
          </table>
          <form [formGroup]="ruleForm" (ngSubmit)="submitRule()" class="rule-form">
            <h6>Neue Regel</h6>
            <label class="rule-form__label">Moodle-Kategorie wählen</label>
            <nb-select formControlName="ref_key" fullWidth placeholder="Kategorie auswählen">
              <nb-option *ngFor="let o of ruleRefOptions" [value]="o.key">{{ o.label }}</nb-option>
            </nb-select>
            <p class="hint" *ngIf="ruleRefOptions.length === 0">Keine Moodle-Kategorien verfügbar (Moodle-Sync nötig).</p>
            <label class="rule-form__label">Start-Semester</label>
            <input nbInput fullWidth type="number" formControlName="default_start_semester" placeholder="1" min="1" max="20" />
            <button
              nbButton
              status="primary"
              size="small"
              type="submit"
              [disabled]="!ruleForm.value.ref_key || !selectedProgramId"
              [nbTooltip]="!selectedProgramId ? 'Zuerst links einen Studiengang wählen' : 'Regel für diesen Studiengang anlegen'"
            >
              Regel anlegen
            </button>
          </form>
          <div class="rule-apply">
            <button
              nbButton
              status="success"
              size="small"
              [disabled]="!selectedProgramId"
              [nbTooltip]="!selectedProgramId ? 'Zuerst links einen Studiengang wählen' : 'Lerner nach diesen Regeln jetzt zuweisen'"
              (click)="applyRules()"
            >
              Regeln jetzt anwenden
            </button>
          </div>
        </section>

        <!-- Spalten verwalten (Custom-Attribute) -->
        <section class="rules-panel" *ngIf="showAttrManager">
          <p class="hint">Spalten der Kurs-Tabelle: Sichtbarkeit umschalten, eigene Spalten anlegen, per Drag&amp;Drop sortieren.</p>

          <span class="rule-form__label">Sichtbare Spalten</span>
          <div class="col-visibility">
            <label class="col-visibility__item"><nb-checkbox [checked]="isColVisible('type')" (checkedChange)="toggleColumn('type')"></nb-checkbox> Typ</label>
            <label class="col-visibility__item"><nb-checkbox [checked]="isColVisible('sem')" (checkedChange)="toggleColumn('sem')"></nb-checkbox> Semester</label>
            <label class="col-visibility__item"><nb-checkbox [checked]="isColVisible('goals')" (checkedChange)="toggleColumn('goals')"></nb-checkbox> Lernziele</label>
            <label class="col-visibility__item" *ngFor="let a of attributes"><nb-checkbox [checked]="isColVisible('attr:' + a.id)" (checkedChange)="toggleColumn('attr:' + a.id)"></nb-checkbox> {{ a.label }}</label>
          </div>

          <h6>Eigene Spalten <span class="muted">— ziehen zum Sortieren</span></h6>
          <div class="attr-list" cdkDropList (cdkDropListDropped)="dropAttribute($event)">
            <div class="attr-item" *ngFor="let a of attributes" cdkDrag>
              <nb-icon icon="menu-outline" class="drag-handle" cdkDragHandle></nb-icon>
              <span class="attr-item__label">{{ a.label }}</span>
              <span class="muted attr-item__meta">{{ a.attr_type }}<ng-container *ngIf="a.attr_type === 'dropdown' && a.options.length"> · {{ a.options.join(', ') }}</ng-container>{{ a.is_required ? ' · Pflicht' : '' }}</span>
              <button nbButton size="tiny" appearance="ghost" status="danger" title="Löschen" (click)="deleteAttribute(a)"><nb-icon icon="trash-2-outline"></nb-icon></button>
            </div>
            <p class="muted" *ngIf="attributes.length === 0">Noch keine eigenen Spalten.</p>
          </div>

          <div class="attr-form">
            <h6>Neue Spalte</h6>
            <input nbInput fullWidth placeholder="Label (z. B. ECTS)" [(ngModel)]="newAttrLabel" />
            <nb-select fullWidth [(ngModel)]="newAttrType" placeholder="Typ">
              <nb-option value="text">Text</nb-option>
              <nb-option value="number">Zahl</nb-option>
              <nb-option value="dropdown">Dropdown</nb-option>
              <nb-option value="boolean">Ja/Nein</nb-option>
            </nb-select>
            <input *ngIf="newAttrType === 'dropdown'" nbInput fullWidth placeholder="Werte (Komma-getrennt: A, B, C)" [(ngModel)]="newAttrOptions" />
            <nb-checkbox [(ngModel)]="newAttrRequired">Pflichtfeld</nb-checkbox>
            <button nbButton status="primary" size="small" [disabled]="!newAttrLabel.trim()" (click)="addAttribute()">Spalte anlegen</button>
          </div>
        </section>

        <!-- Tree-table -->
        <p class="page-hint tree-hint">
          Die Reihenfolge innerhalb einer Gruppe wird nur dort als Abfolge gelesen,
          wo die Gruppe als <strong>Aufbaureihe</strong> markiert ist — dann gilt
          „später setzt früher voraus". Ohne die Markierung ist eine Gruppe eine
          Sammlung zusammengehöriger Kurse ohne feste Abfolge.
        </p>
        <table class="tree-table">
          <thead>
            <tr>
              <th class="col-select">
                <nb-checkbox
                  [checked]="allVisibleSelected"
                  (checkedChange)="toggleSelectAllVisible()"
                  title="Alle sichtbaren Kurse auswählen"
                ></nb-checkbox>
              </th>
              <th>Struktur / Kurs</th>
              <th class="col-release" nbTooltip="Ob ein Agent diese Zeile lesen darf. Vererbt sich von oben nach unten; einzelne Zeilen können abweichen.">Agent</th>
              <th class="col-type" *ngIf="isColVisible('type')"
                  nbTooltip="Wofür die Zeile steht: bei einem Kurs Pflicht oder Wahl, bei einer Gliederungszeile Modul oder Gruppe. Das Symbol links sagt, WAS die Zeile ist, diese Spalte wofür sie steht.">Typ</th>
              <th class="col-num" *ngIf="isColVisible('sem')">Semester</th>
              <th class="col-num" *ngIf="isColVisible('goals')">Lernziele</th>
              <th class="col-attr" *ngFor="let a of visibleAttributes">{{ a.label }}</th>
              <th class="col-actions"></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let row of pagedRows">
              <!-- Group row -->
              <tr *ngIf="row.kind === 'group'" class="tree-row tree-row--group" [class.is-editing]="editGroupId === row.id" [class.just-moved]="isJustMoved(row.id)">
                <!-- Groups are not selectable: this selection exists to put
                     courses INTO a group. -->
                <td class="col-select"></td>
                <td class="tree-cell"><div class="tree-cell__inner">
                  <!-- Guides sit in their own absolutely-positioned layer
                       over the cell, and `.tree-indent` reserves the same
                       width in the flex flow. Painting them as a background on
                       an in-flow span (three earlier attempts) meant fighting
                       the cell's padding and the row border for every pixel,
                       and it could not express "last child" at all. -->
                  <span class="tree-guides" *ngIf="row.depth" [style.width.px]="row.depth * 20"
                        [class.spans-toggle]="!rowHasChildren(row)" aria-hidden="true">
                    <i class="tree-guide" *ngFor="let through of row.guides" [class.is-through]="through"></i>
                    <i class="tree-guide tree-guide--elbow" [class.is-end]="row.isLast"></i>
                  </span>
                  <span class="tree-indent" [style.width.px]="row.depth * 20"></span>
                  <button type="button" class="tree-toggle" *ngIf="rowHasChildren(row)"
                          [class.is-open]="isExpanded(row.id)" (click)="toggleExpand(row.id)"></button>
                  <span class="tree-toggle tree-toggle--leaf" *ngIf="!rowHasChildren(row)"></span>
                  <nb-icon
                    [icon]="rowIcon(row)"
                    [nbTooltip]="rowIconTooltip(row)"
                    class="row-ic"
                  ></nb-icon>
                  <span class="tree-name tree-name--group">{{ row.name }}</span>
                  <span
                    class="order-chip"
                    *ngIf="row.group?.is_ordered"
                    [nbTooltip]="orderHint(row)"
                    >Aufbaureihe</span
                  >
                </div></td>
                <td class="col-release">
                  <nb-icon
                    [icon]="effectiveRelease(row) ? 'checkmark-circle-2-outline' : 'slash-outline'"
                    [class.is-released]="effectiveRelease(row)"
                    [class.is-inherited]="ownRelease(row) === null"
                    [nbTooltip]="releaseLabel(row)"
                  ></nb-icon>
                </td>
                <td class="muted col-type" *ngIf="isColVisible('type')">
                  <span [nbTooltip]="rowTypeTooltip(row)">{{ rowTypeLabel(row) }}</span>
                  <span
                    class="origin-tag"
                    *ngIf="rowOrigin(row)"
                    [nbTooltip]="rowOriginTooltip(row)"
                    >{{ rowOrigin(row) }}</span
                  >
                </td>
                <td class="col-num" *ngIf="isColVisible('sem')"></td>
                <td class="col-num" *ngIf="isColVisible('goals')"></td>
                <td class="col-attr" *ngFor="let a of visibleAttributes"></td>
                <td class="col-actions">
                  <button
                    nbButton
                    ghost
                    size="tiny"
                    status="basic"
                    [nbContextMenu]="rowMenuItems(row)"
                    [nbContextMenuTag]="rowMenuTag(row)"
                    nbContextMenuTrigger="click"
                    title="Aktionen für diese Zeile"
                    aria-label="Aktionen für diese Zeile"
                  >
                    <nb-icon icon="more-vertical-outline"></nb-icon>
                  </button>
                </td>
              </tr>

              <!-- Group edit: its own row instead of fields squeezed into the
                   grid columns, which stacked a checkbox on top of a select. -->
              <tr *ngIf="row.kind === 'group' && editGroupId === row.id" class="tree-row tree-row--edit">
                <td [attr.colspan]="fullColspan">
                  <div class="group-edit" [style.margin-left.px]="(row.depth + 1) * 20">
                    <label class="group-edit__field group-edit__field--name">
                      <span class="group-edit__label">Name</span>
                      <input
                        nbInput
                        size="small"
                        fullWidth
                        [(ngModel)]="editGroupName"
                        placeholder="z. B. Methodenmodul"
                        (keyup.enter)="saveEditGroup()"
                        (keyup.escape)="cancelEditGroup()"
                      />
                    </label>

                    <label class="group-edit__field group-edit__field--type">
                      <span class="group-edit__label">Typ</span>
                      <nb-select size="small" [(ngModel)]="editGroupType" placeholder="ohne">
                        <nb-option value="">ohne</nb-option>
                        <nb-option *ngFor="let t of GROUP_TYPES" [value]="t">{{ t }}</nb-option>
                      </nb-select>
                    </label>

                    <div class="group-edit__field group-edit__field--ordered">
                      <span class="group-edit__label">Reihenfolge</span>
                      <nb-checkbox
                        [(ngModel)]="editGroupOrdered"
                        nbTooltip="An: die Kurse bauen aufeinander auf (Statistik 1 → 2 → 3) — spätere setzen frühere voraus. Aus: die Kurse gehören zusammen, ohne feste Abfolge (z. B. Wahlpflicht)."
                        >Aufbaureihe</nb-checkbox
                      >
                    </div>

                    <div class="group-edit__actions">
                      <button nbButton size="small" status="primary" (click)="saveEditGroup()">Speichern</button>
                      <button nbButton size="small" appearance="ghost" (click)="cancelEditGroup()">Abbrechen</button>
                    </div>
                  </div>
                </td>
              </tr>

              <!-- Inline add-course row -->
              <tr *ngIf="row.kind === 'group' && addCourseForGroup === row.id" class="tree-row tree-row--inline">
                <td [attr.colspan]="fullColspan">
                  <div class="inline-add" [style.padding-left.px]="(row.depth + 1) * 20">
                    <nb-select placeholder="Moodle-Kurs" [(ngModel)]="newCourseId" size="small">
                      <nb-option *ngFor="let c of courseOptions" [value]="c.course_id">{{ c.label }}</nb-option>
                    </nb-select>
                    <button nbButton size="tiny" status="primary" [disabled]="!newCourseId" (click)="confirmAddCourse(row.id)">Hinzufügen</button>
                    <button nbButton size="tiny" status="basic" (click)="startAddCourse(row.id)">Abbrechen</button>
                  </div>
                </td>
              </tr>

              <!-- Course row -->
              <tr *ngIf="row.kind === 'course'" class="tree-row tree-row--course" [class.is-editing]="editItemId === row.id" [class.is-selected]="isItemSelected(row.item?.id)" [class.just-moved]="isJustMoved(row.id)">
                <td class="col-select">
                  <nb-checkbox
                    [checked]="isItemSelected(row.item?.id)"
                    (checkedChange)="toggleItemSelection(row.item?.id)"
                  ></nb-checkbox>
                </td>
                <td class="tree-cell"><div class="tree-cell__inner">
                  <!-- Guides sit in their own absolutely-positioned layer
                       over the cell, and `.tree-indent` reserves the same
                       width in the flex flow. Painting them as a background on
                       an in-flow span (three earlier attempts) meant fighting
                       the cell's padding and the row border for every pixel,
                       and it could not express "last child" at all. -->
                  <span class="tree-guides" *ngIf="row.depth" [style.width.px]="row.depth * 20" aria-hidden="true">
                    <i class="tree-guide" *ngFor="let through of row.guides" [class.is-through]="through"></i>
                    <i class="tree-guide tree-guide--elbow" [class.is-end]="row.isLast"></i>
                  </span>
                  <span class="tree-indent" [style.width.px]="row.depth * 20"></span>
                  <button type="button" class="tree-toggle tree-toggle--goals"
                          [class.is-open]="goalsVisible(row.id)" (click)="toggleGoals(row.item)"></button>
                  <nb-icon [icon]="rowIcon(row)" [nbTooltip]="rowIconTooltip(row)" class="row-ic"></nb-icon>
                  <span class="tree-name">{{ row.name }}</span>
                </div></td>
                <td class="col-release">
                  <nb-icon
                    [icon]="effectiveRelease(row) ? 'checkmark-circle-2-outline' : 'slash-outline'"
                    [class.is-released]="effectiveRelease(row)"
                    [class.is-inherited]="ownRelease(row) === null"
                    [nbTooltip]="releaseLabel(row)"
                  ></nb-icon>
                </td>
                <td class="muted col-type" *ngIf="isColVisible('type')">
                  <nb-checkbox *ngIf="editItemId === row.id; else pflichtView" [(ngModel)]="editItemMandatory">Pflicht</nb-checkbox>
                  <ng-template #pflichtView
                    ><span [nbTooltip]="rowTypeTooltip(row)">{{ rowTypeLabel(row) }}</span></ng-template
                  >
                </td>
                <td class="col-num" *ngIf="isColVisible('sem')">
                  <input *ngIf="editItemId === row.id; else semView" nbInput size="small" type="number" min="1" max="20"
                         class="edit-inline edit-inline--num" [(ngModel)]="editItemSemester" (keyup.enter)="saveEditItem(row)" />
                  <ng-template #semView>{{ row.item?.semester }}</ng-template>
                </td>
                <td class="col-num" *ngIf="isColVisible('goals')">{{ row.item?.learning_goals?.length || 0 }}</td>
                <td class="col-attr" *ngFor="let a of visibleAttributes">
                  <ng-container *ngIf="editItemId === row.id; else attrView" [ngSwitch]="a.attr_type">
                    <nb-checkbox *ngSwitchCase="'boolean'" [(ngModel)]="editItemAttrs[a.id]"></nb-checkbox>
                    <nb-select *ngSwitchCase="'dropdown'" size="small" [(ngModel)]="editItemAttrs[a.id]" placeholder="—">
                      <nb-option value="">—</nb-option>
                      <nb-option *ngFor="let o of a.options" [value]="o">{{ o }}</nb-option>
                    </nb-select>
                    <input *ngSwitchCase="'number'" nbInput size="small" type="number" class="edit-inline--num" [(ngModel)]="editItemAttrs[a.id]" />
                    <input *ngSwitchDefault nbInput size="small" class="edit-inline" [(ngModel)]="editItemAttrs[a.id]" />
                  </ng-container>
                  <ng-template #attrView><span class="muted">{{ attrValue(row.item, a) }}</span></ng-template>
                </td>
                <td class="col-actions">
                  <button
                    nbButton
                    ghost
                    size="tiny"
                    status="basic"
                    [nbContextMenu]="rowMenuItems(row)"
                    [nbContextMenuTag]="rowMenuTag(row)"
                    nbContextMenuTrigger="click"
                    title="Aktionen für diese Zeile"
                    aria-label="Aktionen für diese Zeile"
                  >
                    <nb-icon icon="more-vertical-outline"></nb-icon>
                  </button>
                </td>
              </tr>

              <!-- Goals editor row -->
              <tr *ngIf="row.kind === 'course' && goalsVisible(row.id)" class="tree-row tree-row--goals">
                <td [attr.colspan]="fullColspan">
                  <div class="goals-editor" [style.margin-left.px]="(row.depth + 1) * 20">
                    <div class="content-adopt">
                      <button
                        nbButton
                        size="tiny"
                        status="basic"
                        [disabled]="isProposalLoading(row.id)"
                        (click)="adoptFromLms(row.item)"
                        title="Beschreibung und Lernziele aus der Moodle-Kursbeschreibung bzw. der geparsten Kursstruktur vorschlagen. Nichts wird gespeichert, bis du speicherst."
                      >
                        <nb-icon icon="download-outline"></nb-icon>
                        Aus LMS übernehmen
                      </button>
                      <span class="content-adopt__hint">
                        Vorschlag aus Kursbeschreibung und Kursstruktur — von Hand
                        Geschriebenes wird nicht überschrieben.
                      </span>
                    </div>

                    <label class="content-field">
                      <span class="content-field__label">
                        Beschreibung
                        <em class="content-field__source" *ngIf="sourceLabel(row.id, 'description')">
                          {{ sourceLabel(row.id, 'description') }}
                        </em>
                      </span>
                      <textarea
                        nbInput
                        fullWidth
                        rows="2"
                        placeholder="Worum geht es in diesem Kurs?"
                        [ngModel]="descriptionDraft(row.id)"
                        (ngModelChange)="setDescriptionDraft(row.id, $event)"
                      ></textarea>
                    </label>

                    <div class="content-field__label content-field__label--goals">
                      Lernziele
                      <em class="content-field__source" *ngIf="sourceLabel(row.id, 'goals')">
                        {{ sourceLabel(row.id, 'goals') }}
                      </em>
                    </div>
                    <div class="goals-editor__empty" *ngIf="draftGoals(row.id).length === 0">Noch keine Lernziele.</div>
                    <div class="goal-row" *ngFor="let g of draftGoals(row.id); let i = index">
                      <nb-select [(ngModel)]="g.bloom_level" size="small">
                        <nb-option *ngFor="let lvl of BLOOM_LEVELS" [value]="lvl">{{ lvl }}</nb-option>
                      </nb-select>
                      <input nbInput size="small" fullWidth [(ngModel)]="g.description" placeholder="Lernziel beschreiben" />
                      <button nbButton size="tiny" appearance="ghost" status="danger" (click)="removeDraftGoal(row.id, i)"><nb-icon icon="minus-outline"></nb-icon></button>
                    </div>
                    <div class="goals-editor__actions">
                      <button nbButton size="tiny" status="basic" (click)="addDraftGoal(row.id)">+ Lernziel</button>
                      <button nbButton size="tiny" status="primary" (click)="saveGoals(row.item)">Speichern</button>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>

            <tr *ngIf="visibleRows.length === 0">
              <td [attr.colspan]="fullColspan" class="empty">Noch keine Struktur. Lege links ein Curriculum an (Moodle-Kategorien / Import / manuell) oder füge oben eine Gruppe hinzu.</td>
            </tr>
          </tbody>
        </table>

        <app-pagination
          *ngIf="visibleRows.length > treePageSize"
          class="toolbar-pagination"
          [totalItems]="visibleRows.length"
          [itemsPerPage]="treePageSize"
          [currentPage]="treePage"
          [pageSizeOptions]="pageSizeOptions"
          (pageChanged)="onTreePageChange($event)"
          (itemsPerPageChange)="onTreePageSizeChange($event)"
        ></app-pagination>
      </nb-card-body>
    </nb-card>
    <nb-card class="items" *ngIf="!selectedProgramId">
      <nb-card-body>
        <p class="placeholder">Wähle links einen Studiengang aus, um sein Curriculum zu bearbeiten.</p>
      </nb-card-body>
    </nb-card>
  </div>
</div>
